// OpenAI Ads conversion. Landing loads `oaiq` via the consent banner.
// The dashboard is a different host (app.xpherium.com), so on the Stripe
// success return we load the same pixel just long enough to fire the
// Subscription Created event.

const PIXEL_ID = process.env.REACT_APP_OPENAI_PIXEL_ID || 'K4dpCBrdjfrGYe63v2drXL';
const SCRIPT_ID = 'xph-openai-ads';
const DEDUPE_KEY = 'xph_oai_subscription_created';

function ensurePixel() {
  if (typeof window === 'undefined' || !PIXEL_ID) return;
  if (typeof window.oaiq === 'function') return;
  const queued = [];
  const q = function oaiq(...args) {
    queued.push(args);
  };
  q.q = queued;
  window.oaiq = q;
  if (!document.getElementById(SCRIPT_ID)) {
    const j = document.createElement('script');
    j.id = SCRIPT_ID;
    j.async = true;
    j.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    const first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) first.parentNode.insertBefore(j, first);
    else document.head.appendChild(j);
  }
  window.oaiq('init', { pixelId: PIXEL_ID, debug: false });
}

export function trackSubscriptionCreated(extra = {}) {
  if (typeof window === 'undefined') return;
  try {
    if (window.sessionStorage.getItem(DEDUPE_KEY)) return;
    window.sessionStorage.setItem(DEDUPE_KEY, String(Date.now()));
  } catch {
    // continue
  }
  try {
    ensurePixel();
    if (typeof window.oaiq === 'function') {
      window.oaiq('measure', 'subscription_created', {
        type: 'plan_enrollment',
        ...extra,
      });
    }
  } catch {
    // Ads must never break billing.
  }
}

export default { trackSubscriptionCreated };
